// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__1uCyQ","close":"style_close__CjmEf","scaleImage":"style_scaleImage__jsA3N","mainImage":"style_mainImage__2bv04"};